"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Subtext = _styledComponents.default.span.withConfig({
  displayName: "Subtext",
  componentId: "sc-1l2pvx7-0"
})(["font-size:12px;line-height:20px;color:", ";"], _colors.OBSIDIAN);

var _default = Subtext;
exports.default = _default;
module.exports = exports.default;